module.exports = __webpack_public_path__ + "static/img/P5.74f943d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simba/P5.png
// module id = 5b6H
// module chunks = 0